// extracted by mini-css-extract-plugin
export default {"galeria":"youtube_galeria__LLU95"};